import { BREAKPOINTS, screenSizes } from '@shipt/design-system-themes'
import dynamic from 'next/dynamic'
import { useHydrated } from '@/features/shared/components/ClientOnly'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import styled from 'styled-components'
import { Skeleton } from '@shipt/design-system-loading'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import {
  dismissAppBanner,
  getOpenTheAppBannerVariant,
  isAppBannerDismissed,
} from '@/features/shared/components/AppBanners/utils'

const BannerSkeleton = styled(Skeleton)`
  height: 2.25rem;
  border-radius: 0;

  @media ${screenSizes.tablet} {
    display: none;
  }
`

const DynamicOpenTheAppBanner = dynamic(
  async () =>
    (await import('@/features/shared/components/AppBanners/OpenTheAppBanner')).OpenTheAppBanner,
  {
    ssr: false,
    loading: () => <BannerSkeleton />,
  },
)

export const OpenTheAppBannerContainer = () => {
  const pathname = usePathname() ?? ''
  const isHydrated = useHydrated()
  const isPage = useIsPage()
  const [isDismissedInSession, setIsDismissedInSession] = useState(false)

  const shouldShowVariant = getOpenTheAppBannerVariant(isPage, pathname, 'banner')

  const isDismissed = isDismissedInSession || isAppBannerDismissed()

  // Handle showing/hiding the banner based on the window size and route
  const showBanner =
    isHydrated && window.innerWidth <= BREAKPOINTS.SMALL && shouldShowVariant && !isDismissed

  if (!showBanner) return null

  return (
    <DynamicOpenTheAppBanner
      onDismiss={() => {
        setIsDismissedInSession(true)
        dismissAppBanner()
      }}
    />
  )
}
